import React from 'react';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import Banner from '../components/Banner';
import Reaction from '../components/Reaction';
import Contact from '../components/Contact';
import LastUpdate from '../components/LastUpdate';

const FaqStrukReject = () => {
    React.useEffect(() => {
        window.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
    }, []);

    return (
      <div className="bg-white min-h-screen  flex flex-col">
        <Navbar />
        
        {/* Banner Section */}
        <Banner
            image={process.env.REACT_APP_S3 + "banner_faq.png"} 
            beforePage="FAQ"
            currentPage="Detail FAQ" 
        />
        <div className="mx-auto px-4 md:px-24 w-full relative z-10 mb-16">
          <div className="rounded-2xl md:rounded-3xl">
              <div className="mb-10 md:mb-16 max-w-4xl">
                  <h1 className="text-2xl md:text-3xl lg:text-3xl font-bold text-[#101828] mb-6 leading-snug">
                      Kenapa struk saya ditolak & bagaimana mengatasinya? 
                  </h1>
              </div>

              {/* Mapping Blok Konten (Kiri Teks, Kanan Gambar) */}
              <div className="flex flex-col gap-12 md:gap-20">
                <div className="flex flex-col md:flex-row gap-8 md:gap-12">
                    <div className="w-full md:w-1/2 text-left justify-center md:justify-end">
                        <label className="text-[#101828] text-md md:text-md">
                        <strong>Kenapa struk saya ditolak?</strong>
                      </label>
                      <p className="mt-4 text-[#475467] text-md md:text-md">
                        Ada beberapa alasan struk di tolak, diantaranya :
                      </p>
                      <ol className="list-decimal pl-5 mt-4 text-[#475467] mb-10">
                        <li className="mb-4">
                          Transaksi/struk tidak termasuk dalam program
                        </li>
                        <li className="mb-4">
                          Waktu transaksi melebihi pukul 23:59
                        </li>
                        <li className="mb-4">
                          Tenant bukan dari Summarecon mall
                        </li>
                        <li className="mb-4">
                          Mengupload struk yang sama lebih dari satu kali
                        </li>
                      </ol>
                      <label className="text-[#101828] text-md md:text-md">
                      <strong>Bagaimana cara mengatasinya?</strong>
                      </label>
                      <ol className="list-decimal pl-5 mt-4 text-[#475467]">
                        <li className="mb-4">
                          Upload struk yang asli (bukan hasil print/fotokopi/screenshot/foto dari HP)
                        </li>
                        <li className="mb-4">
                          Upload struk di hari yang sama
                        </li>
                        <li className="mb-4">
                          Pastikan struk belanja berasal dari tenant Summarecon Mall
                        </li>
                        <li className="mb-4">
                          Cukup upload struk satu kali per transaksi
                        </li>
                      </ol>
                    </div>

                    {/* Kolom Kanan: Gambar */}
                    <div className="w-full md:w-1/2 flex items-start md:items-start">
                        {/* Box background hijau/abu-abu muda seperti di desain */}
                        <div className="rounded-3xl px-6 md:px-8 w-full max-w-[640px] flex justify-center items-center">
                            <img
                                src={process.env.REACT_APP_S3+"receipt.png"}
                                className="w-full h-auto object-contain drop-shadow-xl"
                            />
                        </div>
                    </div>
                </div>
              </div>
              <LastUpdate/>
          </div>
        </div>
        <Contact />
        <Footer />
      </div>
    );
}

export default FaqStrukReject;